<template>
  <div class="layout">
    <v-navigation-drawer class="pa-4 pt-8" v-model="drawer" clipped app :width="300">
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="blue lighten-1 white--text"
        >
          <v-list-item :to="{name: 'home-admin'}" exact>
            <v-list-item-icon >
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Início</v-list-item-title>
          </v-list-item>

          <v-list-group  no-action active-class="grey lighten-4">
                <template v-slot:activator>
                  <v-list-item-content title="Processos da Distribuição">
                        <v-list-item-title >Processos da Distribuição</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item :to="{name: 'inscricoes-consulta'}" exact title="Inscrições" >
                  <v-list-item-title>Inscrições</v-list-item-title>
                </v-list-item>

                <v-list-item :to="{name: 'gerar-ranking'}" exact title="Gerar Ranking" >
                <v-list-item-title>Gerar Ranking</v-list-item-title>
                </v-list-item>

                <v-list-item :to="{name: 'cancelar-efetivacao'}" exact title="Cancelar Dia de Efetivação" >
                <v-list-item-title>Cancelar Dia de Efetivação</v-list-item-title>
                </v-list-item>
          </v-list-group>

          <v-list-group  no-action active-class="grey lighten-4" >
                <template v-slot:activator>
                  <v-list-item-content title="Configurações do Sistema">
                        <v-list-item-title >Configurações do Sistema</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item :to="{name: 'pesquisa-configuracao-distribuicao'}" exact title="Configuração da distribuição" >
                  <v-list-item-title >Configuração da distribuição</v-list-item-title>
                </v-list-item>
          </v-list-group>

          <v-list-group no-action active-class="grey lighten-4" >
                <template v-slot:activator >
                  <v-list-item-content >
                    <v-list-item-title >Consultas</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item :to="{name: 'relatorio-email'}" exact title="E-mails">
                  <v-list-item-title>E-mails</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{name: 'relatorio-inscricoes'}" exact title="Inscrições">
                  <v-list-item-title>Inscrições</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'Ranking' }" exact title="Ranking">
                  <v-list-item-title>Ranking</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'distribuicao-professor' }" exact title="Distribuição do professor">
                  <v-list-item-title>Distribuição do professor</v-list-item-title>
                </v-list-item>
                
          </v-list-group>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>

        <div class="pa-2">

          <template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="320"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-export</v-icon>  Sair
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-h5">
          Deseja realmente sair?
        </v-card-title>
        <v-card-text>Ao sair do sistema, você precisará realizar o login novamente no próximo acesso.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue lighten-1"
            text
            @click="dialog = false"
          >
            Permanecer
          </v-btn>
          <v-btn
            color="blue lighten-1"
            text
            @click="sair()"
          >
            Sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar clipped-left app color="white" elevation="1">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Distribuição de Cargos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        open-on-click
        offset-x
        offset-y
        min-width="150"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            ref="btnMenu"
            dark
            v-bind="attrs"
            v-on="on"
            class="user-info"
            text
            color="black"
          >
            <v-icon x-large>mdi-account</v-icon>
            <span class="mx-2"
              >Administrador<span class="user-matricula"
                >{{$store.state.cdlogin}}</span
              ></span
            >
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Alterar ano letivo</v-card-title>
          <v-card-text>
            <v-text-field
              type="text"
              label="Ano Letivo"
              outlined
              hide-details="auto"
              v-model="aaletivo"
              v-mask="'####'"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="menu = false">Cancelar</v-btn>
            <v-btn color="primary" text @click="onSubmit">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-container class="pa-12">
      <v-row class="px-3">
        <v-col>
          <BreadCrumb/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask"

export default {
  components: {
    BreadCrumb
  },
  directives: { mask },

  async beforeRouteEnter(to, from, next) {
    if (sessionStorage.cdlogin) {
      next();
      // next();
    } else {
      next("/");
    }
  },
  data() {
    return {
      drawer: true,
      group: null,
      aaletivo: null,
      menu: false,
      dialog: false,
    };
  },
  async created() {
    if (this.getAnoLetivo == null) {
      this.setAnoLetivo = 2022;
    } else {
      this.aaletivo = this.getAnoLetivo;
    }

    var style = document.createElement("style");
    style.type = 'text/css';
    style.title="marcelocss";
    style.innerHTML = '::-webkit-scrollbar { width: 10px; } ::-webkit-scrollbar-track { background: #f3f5f7; } ::-webkit-scrollbar-thumb { background: rgb(88,176,246); box-shadow: inset 0px 0px 1px 1px rgb(88,176,246); border-radius: 5px; } ::-webkit-scrollbar-thumb:hover { background: rgb(88,176,246); box-shadow: inset 0px 0px 1px 1px rgb(88,176,246);}';
    document.getElementsByTagName("head")[0].appendChild(style);

  },
  async beforeDestroy() {
    let style = document.querySelector("style[title='marcelocss']");
    if (style.parentNode) {
      style.parentNode.removeChild(style);
    }
  },
  methods: {
    onSubmit() {
      this.menu = false
      this.setAnoLetivo(this.aaletivo);
      this.$router.push("/admin/");
    },

    cancelar() {
      this.$refs.btnMenu.$el.on = false;
    },

    sair() {
      this.dialog = false
      this.$router.push("/")
    },

    ...mapActions(["setAnoLetivo"]),
  },
  computed: {
    ...mapGetters(["getAnoLetivo"]),
  },
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

.layout {
  font-family: "Roboto", sans-serif;
  background-color: rgb(246,246,246); /*rgb(241, 245, 248);*/ /*rgb(251, 252, 255); */
  min-height: calc(100vh -  64px);
  margin: 0;
  padding: 0;
  /* color: #ffffe2; */
}

.menu {
  background-color: red !important;
  /* color: black; */
  height: 100vh;
  padding: 30px 30px;
  margin: 50px;
}
.menu .menu-header {
  margin-bottom: 30px;
}
.menu .menu-content .menu-item {
  color: #667486;
  font-weight: 500;
  padding: 10px 10px;
  cursor: pointer;
}
.menu .menu-content .menu-item.menu-item-active {
  background-color: #f8f9fd;
  border-radius: 10px;
}
.menu .menu-content .menu-item .menu-option svg {
  display: inline-block;
  margin-right: 10px;
}

.header-bar {
  background-color: #ffffff;
  padding: 20px 20px;
}

.content {
  background-color: #edf0f8;
  padding: 25px 30px;
}

.user-info span {
  text-transform: capitalize;
  text-align: left;
  font-size: 13px;
}
.user-matricula {
  display: block !important;
  font-size: 11px !important;
}

#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > div.v-list-group.v-list-group--active.v-list-group--no-action.primary--text > div.v-list-group__items > a {
  padding-left: 20px;
}

#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > div.v-list-group.v-list-group--active.v-list-group--no-action.primary--text > div.v-list-group__items > div {
  padding-left: 20px;
}


.v-application--is-ltr .v-list-item__action:first-child, 
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px;
    
}
#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > div.v-list-group.v-list-group--active.v-list-group--no-action.primary--text > div.v-list-group__items > a > div.v-list-item__icon {
  margin-right: 5px;
}
#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > a > div.v-list-item__icon {
  margin-right: 5px;
}

#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > div:nth-child(4) > div > div.v-list-item__icon.v-list-group__header__prepend-icon {
  
  margin-right: 5px;
}
#app > div.v-application--wrap > main > div > div > nav > div.v-navigation-drawer__content > div > div > div:nth-child(4) > div.v-list-group__header.v-list-item.v-list-item--link.theme--light > div.v-list-item__icon.v-list-group__header__prepend-icon {
  
  margin-right: 5px;
}




</style>